module.exports = "//static.hsappstatic.net/two-factor-prompt-lib/static-1.3485/img/hubspotMobileApp.png"